import { render } from "./linktree.vue?vue&type=template&id=49edddfc"
const script = {}

import "./linktree.vue?vue&type=style&index=0&id=49edddfc&lang=css"

import exportComponent from "/home/bovero/Downloads/sito_vue3/vueboot5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__